export const environment = {
    production: true,
    urlserver: {
      laravelApi: 'https://walldev.archiviomisericordia.it/api/',
      laravelApiMisericordia: 'https://walldev.archiviomisericordia.it/api/misericordia/',
      laravelApiMultimedia: 'https://walldev.archiviomisericordia.it/api/misericordia/multimedia/',
      laravel: 'https://walldev.archiviomisericordia.it/'
    }
  };
